
(function() {

	// Track all outstanding ajax requests
	var g_jqXHRs = [];
	// used to prevent multiple cascading alerts
    var g_AjaxAlertDisplayed = false;

	$(document).ajaxSend(function(e, jqXHR, options)
	{
		g_jqXHRs.push(jqXHR);
	});
	$(document).ajaxComplete(function(e, jqXHR, options)
	{
		g_jqXHRs = $.grep(g_jqXHRs, function(x) {return x != jqXHR});
	});

	$(window).on('beforeunload', ClearAjaxRequests);

	// Clear all current AJAX requests. Done when changing pages.
	function ClearAjaxRequests()
	{
		$.each(g_jqXHRs, function (i, xhr)
		{
			xhr.abort();
		});
		g_jqXHRs = [];
	}

	// Abstraction layer for calling jquery's ajax
	// Deprecated - use $.ajax()
	window.Ajax = function (obj)
	{
		// This AJAX flag is probably no longer necessary
		if (obj.data == undefined)
			obj.data = 'AJAX=1';
		else if (typeof(obj.data) == 'string')
			obj.data += '&AJAX=1';
		else if (typeof(obj.data) == 'object')
			obj.data.AJAX = '1';

		return $.ajax(obj);
	}

	window.ParseJson = function (Response)
	{
		return ParseAjaxResponse(Response);
	}

	window.ParseAjaxResponse = function (Response)
	{
		var Incoming = null;
		var Exp = null;

		if (isJSON(Response))
		{
			try
			{
				Incoming = JSON.parse(Response);
			}
			catch (Exp)
			{
				// Fall through
			}
		}
		else if (typeof Response == 'string')
		{
			return Response;
		}
		else // if (Array.isArray(Response))
		{
			// Already parsed json passed in
			Incoming = Response;
		}

		if (Incoming == null)
		{
			OverrideSaveCheck = true;

			DisplayAjaxError(Exp, null, Response);

			return null;
		}
		
		if(Incoming.Alert === 'The password is incorrect')
		{
			return Incoming;
		}

		if (Incoming.Alert)
		{
			// Dont show an alert message for expired tokens.
			if (Incoming.Alert != 'Notice: Token is invalid or has timed out.')
			{
 				DoAjaxAlert(Incoming.Alert);
			}

			if (Incoming.Alert == 'Session is invalid or has timed out')
			{
				// redirect to the login page  
				window.location.assign('/login.php?error=' + Incoming.Alert);
			}

			return null;
		}

		return Incoming;
	}

	// From https://github.com/douglascrockford/JSON-js/blob/master/json2.js
	// Returns true if text is JSON, else returns false
	function isJSON(text)
	{
		// We split the second stage into 4 regexp operations in order to work around
		// crippling inefficiencies in IE's and Safari's regexp engines. First we
		// replace the JSON backslash pairs with '@' (a non-JSON character). Second, we
		// replace all simple value tokens with ']' characters. Third, we delete all
		// open brackets that follow a colon or comma or that begin the text. Finally,
		// we look to see that the remaining characters are only whitespace or ']' or
		// ',' or ':' or '{' or '}'. If that is so, then the text is safe for eval.
		try
		{
			return /^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, '@')
					.replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']')
					.replace(/(?:^|:|,)(?:\s*\[)+/g, ''));
		}
		catch(e)
		{
			return false;
		}
	}

	window.DisplayJsonError = function(e, http_request)
	{
		DisplayAjaxError(e, http_request.status, http_request.responseText);
	}

	window.DisplayAjaxError = function(e, ResponseStatus, ResponseText)
	{
		OverrideSaveCheck = true;

		var Str = "Error processing AJAX reply:\n";

		if (ResponseStatus)
		{
			if (ResponseStatus == 'abort')
			{
				// Probably from a page navigation - see ClearAjaxRequests()
				return;
			}
			Str += 'Response Status: ' + ResponseStatus + "\n";
		}
		else
		{
			Str += 'Response Status: (Unknown)\n';
		}

		if ((typeof(e) == 'object') && (e != null))
		{
			Str += e.message;
			// Str += e.stack;
		}
		else if (typeof(e) == 'string')
		{
			if (e != '')
				Str += 'Error: ' + e;
		}
		else if (ResponseText.length > 0)
		{
			Str += 'Response Text: ' + ResponseText;
		}
		else
		{
			Str += 'Response Text: (no text returned)';
		}

		if (Str.length > 800)
		{
			// Ensure to display the end of the message which sometimes contains an
			// appended error
			Str = Str.substring(0, 400) + '\n ...\n' + Str.substring(Str.length - 400);
		}

		DoAjaxAlert(Str);
	}

	window.DoAjaxAlert = function (string)
	{
		if (!g_AjaxAlertDisplayed)
		{
			g_AjaxAlertDisplayed = true;
			alert(string);
		}
	}

	window.ClearAjaxAlertFlag = function ()
	{
		g_AjaxAlertDisplayed = false;
	}

} ());
